import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from "@angular/router";
import { environment } from '../../../environments/environment';
import { AppConfig, SearchCriteria, FacetSearchCriteria, SearchResult, Preset } from "../webapi/faceted-search-app.model";
import { FacetedSearchAppService } from "../webapi/faceted-search-app.service";
import { forEach } from '@angular/router/src/utils/collection';
import { CurrentUserService } from '../../security/current-user.service';


@Component({
  selector: 'faceted-search-app',
  templateUrl: './faceted-search-app.component.html',
  styleUrls: ['./faceted-search-app.component.css']
})

export class FacetedSearchAppComponent implements OnInit {

  constructor(private facetedSearchAppService: FacetedSearchAppService, private currentUserService: CurrentUserService) {
  }

  @Output()
  onError = new EventEmitter<number>();

  errorMessage: string;

  //config: AppConfig;

  onSearchCriteriaChanged(/*criteria: SearchCriteria*/e: any) {

    this.facetedSearchAppService.search(/*criteria*/)
      .then(response => {
        console.log("faceted-search-app-component:" + response);
        this.errorMessage = "";
      })
      .catch(error => {
        Promise.reject(error);
        //this.errorMessage = "Your session timed out.";
        //this.facetedSearchAppService.errorDialog(error.statusText || this.errorMessage);
      });
  }


  ngOnInit(): void {
    this.facetedSearchAppService.initialize();
  }
}





// WEBPACK FOOTER //
// ./src/app/fsapplication/faceted-search-app/faceted-search-app.component.ts